import React from 'react';
import sendEvent from '../../helpers/tracking';

import './ProductCard.scss';
import { link } from '../../helpers/link';

export default function ProductCard({
  id, uri, title, subTitle, imageUrl, itemCardTracking, NextLink
}) {
  return NextLink ?
    <div className="productCard" onClick={() => {
      sendEvent(...itemCardTracking);

      location.href = `${uri}/${id}`;
    }}>
      <img
        className="productCard-image"
        src={imageUrl} alt="product-image" />

      <h4 className="productCard-title">{title}</h4>
      <h5 className="productCard-subtitle">{subTitle}</h5>
    </div> :
    <div className="productCard-full">
      <h4 className="productCard-title-mobile">{title}</h4>

      <div className="productCard">
        <img
          className="productCard-image"
          src={imageUrl} alt="product-image" />

        <h4 className="productCard-title-desktop">{title}</h4>
        <h5 className="productCard-subtitle">{subTitle}</h5>
      </div>
    </div>
}
